module.exports = __webpack_public_path__ + "media/images/icons/thumb-up-44bbb17e501e3a3575be8bef64a3c7a5.svg";